import { render, staticRenderFns } from "./IlluDateChoix.vue?vue&type=template&id=c2004d74&"
import script from "./IlluDateChoix.vue?vue&type=script&lang=js&"
export * from "./IlluDateChoix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports